import api from "@/libs/axios";
import { QueryConfig } from "@/libs/query";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { apiEnum } from "@shared/types/enums/apiEnum";
import { OrganizerEntity } from "./entities/organizerEntity";
import { QUERY_KEY } from "@/pages/taskpane/shared/constants/queryKey";

type PayloadType = {
  searchText: string;
  organizerEmail: string;
};
const getOrganizerAssistant = async ({ organizerEmail, searchText }: PayloadType) => {
  const { data } = await api.get(
    apiEnum.getOrganizerAssistant + `?searchText=${searchText}&organizerEmail=${organizerEmail}`
  );
  return (data?.data?.assistants || []).map((item: any) => new OrganizerEntity(item));
};

export const options = ({ organizerEmail, searchText }: PayloadType) =>
  queryOptions({
    queryKey: [QUERY_KEY.GET_ORGANIZER_ASSISTANT, organizerEmail, searchText],
    queryFn: () => getOrganizerAssistant({ organizerEmail, searchText }),
    staleTime: 5 * 60 * 1000,
  });

type GetType = {
  queryConfig?: QueryConfig<typeof options>;
  payload: PayloadType;
  enabled?: boolean;
};

export const useGetOrganizerAssistant = ({ queryConfig, payload, enabled = true }: GetType) => {
  return useQuery({
    ...options(payload),
    ...queryConfig,
    enabled: enabled,
  });
};
